import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Link, useHistory } from 'react-router-dom'
import moment from 'moment';
import { Modal } from "react-bootstrap";
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import './date-range.css'
import { TbProgress } from "react-icons/tb";
import { Timeline, Pagination, Tooltip } from 'antd';
import { ClockCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import Select, { components } from 'react-select';

import { useTheme } from "./theme-provider.js"
import { getCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js"
import PageError from '../common_component/PageError.js';
import TableColumnHead from "../common_component/TableColumnHead.js";
import StatusBadge from "../common_component/StatusBadge.js";
import formatNumber from "../common_component/formatNumber.js";
import { useModal } from '../providers/modal-provider.js';

const CustomerInvoiceList = () => {
    const { openModal, setModalView, setModalData } = useModal();
    const { theme, dropdownStyleDark } = useTheme()
    const [state, setstate] = useState(2);
    const [paymentCredentials, setPaymentCredentials] = useState([]);
    const history = useHistory();
    const customerListApiController = useRef(new AbortController())

    const [configGstinList, setConfigGstinList] = useState([])
    const [transporterResults, setTransporterResults] = useState([])

    const [transporterApiState, setTransporterApiState] = useState(false)
    const [PaidThroughAccount, setPaidThroughAccount] = useState(null)
    const [PaidThroughAccountlist, setPaidThroughAccountlist] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [branchList, setBranchlist] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [customerApiState, setCustomerApiState] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const [invoiceList, setInvoiceList] = useState([])
    const [listCount, setListCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [sortColumn, setSortColumn] = useState(null)
    const [sortValue, setSortValue] = useState(null)
    const [searchValue, setSearchValue] = useState(null)
    const [startDate, setStartDate] = useState(moment.utc().subtract(6, "days").format("YYYY-MM-DD"))
    const [endDate, setEndDate] = useState(moment.utc().format("YYYY-MM-DD"))
    const [invoiceListApiState, setInvoiceListApiState] = useState(false);

    const [configurePaymentModalShow, setConfigurePaymentModalShow] = useState(false);
    const [paymentLinkListModalShow, setPaymentLinkListModalShow] = useState(false);
    const [dataFlag, setDataFlag] = useState(false);
    const [totalPaidAmount, setTotalPaidAmount] = useState(0);
    const [paymentLinkList, setPaymentLinkList] = useState([]);
    const [invoiceDetails, setInvoiceDetails] = useState(null);
    const [customerContactDetails, setCustomerContactDetails] = useState(null);
    const [defaultPaymentAccount, setDefaultPaymentAccount] = useState(null);
    const [linkMedium, setLinkMedium] = useState("Email");
    const mediumList = ['Email'];
    const phonemediumList = ['SMS', 'Whatsapp'];
    const [phoneMedium, setPhonemedium] = useState("");
    const [mediumValue, setMediumValue] = useState("");
    const [allowPartial, setAllowPartial] = useState(false);
    const [amount, setAmount] = useState(0);
    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);

    const [paymentLinkDetails, setPaymentLinkDetails] = useState(null);
    const [cancelPaymentLinkModalShow, setCancelPaymentLinkModalShow] = useState(false);
    const [resendPaymentLinkModalShow, setResendPaymentLinkModalShow] = useState(false);

    const [timezone_change, set_timezone_change] = useState("+00:00");
    const [branchesList, setBranchesList] = useState([])
    const [progressModalShow, setProgressModalShow] = useState(false)
    const [progressStatus, setProgressStatus] = useState([])
    const [flowApiState, setFlowApiState] = useState(false)

    const daterange_picker_ref = useRef()

    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [einvoiceMode, setEinvoiceMode] = useState(null)

    const [invoiceStatus, setInvoiceStatus] = useState(null)
    const [invoiceStatusModalShow, setInvoiceStatusModalShow] = useState(false)
    const [invoiceStatusApiState, setInvoiceStatusApiState] = useState(false)

    const [configGstinListModalShow, setConfigGstinListModalShow] = useState(false)
    const [selectedOrganizationGstin, setSelectedOrganizationGstin] = useState(null)
    const [einvoiceSubmitButtonState, setEinvoiceSubmitButtonState] = useState(false)

    const [ewbDetailsModalShow, setEwbDetailsModalShow] = useState(false)
    const [selectedTransporter, setSelectedTransporter] = useState(null)
    const [distance, setDistance] = useState("")
    const [modeOfTransportation, setModeOfTransportation] = useState("road")
    const [vehicleType, setVehicleType] = useState("regular")
    const [vehicleNo, setVehicleNo] = useState("")
    const [transportBillDocNo, setTransportBillDocNo] = useState("")
    const [transportBillDocDate, setTransportBillDocDate] = useState("")

    const [cancelReason, setCancelReason] = useState("")

    const [transporterModalShow, setTransporterModalShow] = useState(false)
    const [transporterList, setTransporterList] = useState([])
    const [transporterPanel, setTransporterPanel] = useState(false)
    const [transporterUid, setTransporterUid] = useState(null)
    const [transporterName, setTransporterName] = useState("")
    const [transporterId, setTransporterId] = useState("")
    const [transporterSubmitButtonState, setTransporterSubmitButtonState] = useState(false)

    const [flowModalShow, setFlowModalShow] = useState(false)

    var page_name = "customer-invoice-list";
    const search_length = 1;

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    let formatNumberOptions = {
        removeTrailingZeros: true
    }

    const handleOpenRevertModal = (obj) => {
        setModalData({
            customer_invoice_id: obj.customer_invoice_id,
            organization_id: obj.organization_id, // or your global organization_id variable
            page_name,
            apiCallback: (updatedInfo) => {
                // Refresh your table/list data here after successful revert
                getBasicInvoicesList(currentPage, rowsPerPage, sortColumn, sortValue, searchValue, startDate, endDate);
                console.log("Successfully reverted, refreshing list...", updatedInfo);
                // fetchTableData();
            },
            modalCloseCallback: () => {
                console.log("Revert modal closed");
            }
        });
        setModalView("REVERT_MODAL");
        openModal();
    };

    async function getPaymentCredential() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/fetch-payment-credential`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") {
            if (body.data.length > 0) {
                const default_payment_credential = body.data[0].payment_credentials.find(x => x.default == true);
                setDefaultPaymentAccount({ label: `${default_payment_credential.platform} ${default_payment_credential.account_id}`, value: default_payment_credential.account_id });
                setPaymentCredentials(body.data[0].payment_credentials);
            }
        }
    }

    async function getBranchDetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-branches`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation == "success") {
            setBranchlist(body.data);
            let temp = body.data.filter(option => option.default_branch == "yes")
            if (temp.length > 0) {
                setSelectedBranch({ label: temp[0].branch_name, value: temp[0].branch_id });
            }
        }
        else {
            throw "branch list api error"
        }
    }

    async function selectiveAccountHead() {
        let arr = [
            { "category_name": "Assets", "headArray": [] },
            { "category_name": "Equity", "headArray": [] },
            { "category_name": "Income", "headArray": [] },
            { "category_name": "Bank", "headArray": [] }
        ]
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/selective-account-head`, { method: 'POST', body: JSON.stringify({ "organization_id": organization_id, "headRequest": arr, "email": user.email, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation === "success") {
            let temp_dropdown = [];
            body.data.map((obj) => {
                var temp_obj = {};
                temp_obj.label = obj.category_name;
                temp_obj.id = obj.cid;
                let temp_dropdown1 = [];
                obj.headArray.map((obj1) => {
                    var temp_obj1 = {};
                    temp_obj1.label = obj1.name;
                    temp_obj1.value = obj1.hid;
                    temp_dropdown1.push(temp_obj1);
                    if (obj1.name === "Petty Cash") {
                        setPaidThroughAccount(temp_obj1);
                    }
                })
                temp_obj.options = temp_dropdown1;
                if (obj.category_name === "Assets" || obj.category_name === "Equity" || obj.category_name === "Income" || obj.category_name === "Bank") {
                    temp_dropdown.push(temp_obj);
                }
            })
            setPaidThroughAccountlist(temp_dropdown);
        }
    }

    const checkPendingPayment = () => {
        var values = { "page_name": page_name, "user_flag": true, "user_flag": "customer", "invoice_id": invoiceDetails.customer_invoice_id, "customer_id": invoiceDetails.customer_id, "organization_id": organization_id };
        setDataFlag(true);
        setMainSubmitButtonState(true);
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/check-pending-payment`, values, headers).then((res) => {

            if (res.data && res.data.operation == "success") {
                if (Number(invoiceDetails.grand_total) - Number(res.data.total_paid_amount) > 0) {
                    setCustomerContactDetails(res.data.contact_details);
                    setTotalPaidAmount(res.data.total_paid_amount);
                    setAmount(Number(invoiceDetails.grand_total) - Number(res.data.total_paid_amount));
                    setDataFlag(false);
                    setMainSubmitButtonState(false);
                }
                else {
                    swal("Oops!", "Your payment for the invoice has been processed successfully. No further action is required.", "error");
                    setConfigurePaymentModalShow(false);
                    setDataFlag(false);
                    setMainSubmitButtonState(false);
                }
            }
        });
    }

    const fetchPaymentLinkList = (id, obj) => {
        var values = { "invoice_id": id, "page_name": page_name, "organization_id": organization_id };
        setDataFlag(true);
        setMainSubmitButtonState(true);
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/payment-link-list`, values, headers).then((res) => {

            if (res.data && res.data.operation == "success") {
                setPaymentLinkList(res.data.data);
            }
            setDataFlag(false);
            setMainSubmitButtonState(false);
        });
    }

    const sharePaymentLink = (e) => {
        e.preventDefault();
        if (defaultPaymentAccount == null) {
            swal("Oops!", "You need to select Payment Account", "error");
            return
        }
        if (linkMedium == "") {
            swal("Oops!", "You need to select link medium", "error");
            return
        }
        if (linkMedium == "Phone") {
            if (phoneMedium == "") {
                swal("Oops!", "You need to select phone medium", "error");
                return
            }
            if (mediumValue == "") {
                swal("Oops!", "You need to fill phone field", "error");
                return
            }
        }
        else {
            if (mediumValue == "") {
                swal("Oops!", "You need to fill email field", "error");
                return
            }
        }

        if (amount == 0) {
            swal("Oops!", "Payment amount should be greater than zero", "error");
            return
        }
        var values = { "id": invoiceDetails.customer_invoice_id, "paid_through_account": PaidThroughAccount.value, "account_category": PaidThroughAccountlist.find(x => x.options.map(a => a.value).includes(PaidThroughAccount.value)).id, "branch_id": selectedBranch.value, "default_payment_account": defaultPaymentAccount.value, "link_medium": linkMedium, "phone_medium": phoneMedium, "medium_value": mediumValue, "allow_partial": allowPartial, "currency": invoiceDetails.invoice_currency.currency_code, "amount": amount, "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/share-payment-link`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", `Payment link has been sent to your email. Please check your inbox.`, "success").then((value) => {
                    configurePaymentDetails(invoiceDetails.customer_invoice_id);
                    setConfigurePaymentModalShow(false);
                });
            }
            else if (res.data.message == "invoice_amount_exceed") {
                swal("Oops!", "The invoice has been fully paid, and no further action is required.", "error");
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    const cancelPaymentLink = () => {
        var values = { "invoice_id": invoiceDetails.customer_invoice_id, "id": paymentLinkDetails.unique_id, "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/cancel-payment-link`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Payment link cancelled successfully!", "success").then((value) => {
                    configurePaymentDetails(invoiceDetails.customer_invoice_id);
                    setCancelPaymentLinkModalShow(false);
                });
            }
            else if (res.data.message == "cancel_count_reached") {
                swal("Oops!", "Cancellation limit reached. You cannot proceed with cancellation.", "error");
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    const resendPaymentLink = () => {
        var values = { "id": paymentLinkDetails.unique_id, "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/reshare-payment-link`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Payment link has been resent to your email. Please check your inbox.", "success").then(() => {
                    configurePaymentDetails(invoiceDetails.customer_invoice_id);
                    setCancelPaymentLinkModalShow(false);
                });
            }
            else if (res.data.message == "invoice_amount_exceed") {
                swal("Oops!", "The invoice has been fully paid, and no further action is required.", "error");
            }
            else if (res.data.message == "resend_count_reached_per_day") {
                swal("Oops!", "You've reached your daily resend limit. Please try again tomorrow.", "error");
            }
            else if (res.data.message == "resend_count_reached") {
                swal("Oops!", "Resend limit reached. You cannot proceed with resend operation.", "error");
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    async function getBasicInvoicesList(cp, rpp, sort_c, sort_v, search_v, sd, ed, customer_id) {
        setInvoiceListApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-basic-customer-invoice-list`, { method: 'POST', body: JSON.stringify({ "email": user.email, "current_page": cp - 1, "rows_per_page": rpp, "sort_column": sort_c, "sort_value": sort_v, "search_value": search_v, "customer_id": customer_id || null, "start_date": sd, "end_date": ed, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            setInvoiceList(body.data.list);
            setListCount(body.data.count)
            setInvoiceListApiState(false)
        }
        else {
            throw "basic invoice list api error"
        }
    }
    async function getBranches() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-branches`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body.data)
        if (body.operation == "success") {
            setBranchesList(body.data)
        }
    }

    const getProgressByStatus = async (customer_invoice_id) => {
        setFlowApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-customer-order-invoice-timeline`, { method: 'POST', body: JSON.stringify({ "email": user.email, "customer_invoice_id": customer_invoice_id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation === "success") {
            setProgressStatus(body.data)
        }
        else {
            swal("Oops!", "Couldn't get order flow", "warning")
        }
        setFlowApiState(false)
    }

    const getInvoiceStatus = async (invoice_id) => {
        setInvoiceStatusApiState(false)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-customer-invoice-status`, { method: 'POST', body: JSON.stringify({ "email": user.email, "invoice_id": invoice_id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        setInvoiceStatus(body);
        setInvoiceStatusApiState(true);
    }

    async function getTimezoneInformation() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-organization-timezone-information`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") {
            if (body.data.length > 0) {
                if (body.data[0].timezone_value != "" && body.data[0].timezone_value != null) {
                    const timezone = body.data[0].timezone_value;
                    set_timezone_change(timezone);
                }
            }
        }
        else {
            throw "timezone api error"
        }
    }


    async function getConfigGstinList() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-e-way-bill-config-status-list`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)
        if (body.length !== 0) {
            setConfigGstinList(body.data)
        }
    }
    async function getTransporters(search_value) {
        setTransporterApiState(true);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-transporter-by-search`, { method: 'POST', body: JSON.stringify({ "email": user.email, "search_value": search_value, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)

        if (body.operation === "success") {
            setTransporterResults(body.data.list.filter(x => x.add_status == "Active"))
            setTransporterApiState(false);
        }
        else {
            throw "transporter list api error"
        }
    }
    async function getAllTransporters() {

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-transporter-list`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)

        if (body.operation === "success") {
            setTransporterList(body.data)
        }
        else {
            throw "all transporter list api error"
        }
    }

    async function getCustomers(search_value) {
        try {
            if (customerApiState) {
                customerListApiController.current.abort()
                customerListApiController.current = new AbortController()
            }
            setCustomerApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-customer-by-search`, { signal: customerListApiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "search_value": search_value, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();

            if (body.operation === "success") {
                setCustomerList(body.data.list.filter(x => x.add_status === "Active"))
                setCustomerApiState(false);

                return body.data.list
            }
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    useEffect(() => {
        if (((read) || (write)) && (user.email && visibility)) {
            let p1 = getBasicInvoicesList(currentPage, rowsPerPage, sortColumn, sortValue, searchValue, startDate, endDate);
            let p2 = getBranches();
            let p3 = getTimezoneInformation();
            let p4 = getConfigGstinList()
            let p5 = getTransporters()
            let p6 = getPaymentCredential()
            let p7 = getBranchDetails();
            let p8 = selectiveAccountHead();
            let p9 = getCustomers();
            Promise.all([p1, p2, p3, p4, p5, p6, p7, p8, p9])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((errx) => {
                    console.log(errx)
                    setstate(3)
                })
        }
    }, [user, visibility, read, write])

    useEffect(() => {
        if (state == 1) {
            getBasicInvoicesList(currentPage, rowsPerPage, sortColumn, sortValue, searchValue, startDate, endDate, selectedCustomer?.cid)
        }
    }, [currentPage, rowsPerPage, sortColumn, sortValue, searchValue, startDate, endDate, selectedCustomer])

    const processEinvoice = () => {

        if (selectedOrganizationGstin == null) {
            swal("Oops", "Please select a Gstin with E-Way Bill Configuration before generating E-Way Bill", "warning")
            return
        }

        if ((einvoiceMode === "generate_irn_with_ewb") || (einvoiceMode === "generate_ewb_against_irn")) {
            if (selectedTransporter == null) {
                swal("Oops!", "Select a transporter", "warning");
                return false
            }
            if (distance == "") {
                swal("Oops!", "Enter a valid Distance in km", "warning");
                return false
            }
            if (vehicleNo == "") {
                swal("Oops!", "Vehicle No. cannot be empty", "warning");
                return false
            }
            if (transportBillDocNo == "") {
                swal("Oops!", "Enter valid document no.", "warning");
                return false
            }
            if (transportBillDocDate == "") {
                swal("Oops!", "Enter valid document date", "warning");
                return false
            }
        }

        if ((einvoiceMode === "cancel_irn") || (einvoiceMode === "cancel_irn_ewb")) {
            if (cancelReason === "") {
                swal("Oops!", "Enter a vaild message", "warning");
                return false
            }
        }

        var object = {}

        object.invoice_id = selectedInvoice.customer_invoice_id
        object.organization_gstin_uid = selectedOrganizationGstin

        if ((einvoiceMode === "generate_irn_with_ewb") || (einvoiceMode === "generate_ewb_against_irn")) {
            object.ewb_details = {
                transporter_uid: selectedTransporter.value,
                transporter_name: selectedTransporter.label,
                distance: distance,
                mode_of_transportation: modeOfTransportation,
                vehicle_type: vehicleType,
                vehicle_no: vehicleNo,
                transporter_bill_doc_no: transportBillDocNo,
                transporter_bill_doc_date: moment(transportBillDocDate).utc().format(),
            }
        }

        if ((einvoiceMode === "cancel_irn") || (einvoiceMode === "cancel_irn_ewb")) {
            object.reason = cancelReason
        }

        object.organization_id = organization_id
        object.page_name = page_name;


        console.log(object);
        setEinvoiceSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        let url = ""
        if (einvoiceMode === "generate_irn") {
            url = "generate-e-invoice-irn"
        }
        else if (einvoiceMode === "generate_irn_with_ewb") {
            url = "generate-e-invoice-irn-with-ewb-details"
        }
        else if (einvoiceMode === "generate_ewb_against_irn") {
            url = "generate-ewb-against-irn"
        }
        else if (einvoiceMode === "get_qr_image") {
            url = "get-qr-against-irn"
        }
        else if (einvoiceMode === "cancel_irn") {
            url = "cancel-e-invoice-irn"
        }
        else if (einvoiceMode === "cancel_irn_ewb") {
            url = "cancel-e-invoice-ewb"
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/${url}`, object, headers).then((res) => {
            setEinvoiceSubmitButtonState(false)
            getBasicInvoicesList(currentPage, rowsPerPage, sortColumn, sortValue, searchValue, startDate, endDate);
            handleConfigGstinListModalClose()
            if (res.data.operation === "success") {
                swal("Great!", res.data.message, "success")
            }
            else {
                swal("Oops!", res.data.message, "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const handleConfigGstinListModalClose = () => {
        setSelectedInvoice(null)
        setConfigGstinListModalShow(false)

        setSelectedOrganizationGstin(null)

        setCancelReason("")

        handleEwbDetailsModalClose()
    }

    const handleInvoiceStatusModalClose = () => {
        setInvoiceStatusModalShow(false);
        setInvoiceStatus(null);
    }

    const handleEwbDetailsModalClose = () => {
        setEwbDetailsModalShow(false)
        setEinvoiceMode(null)

        setSelectedTransporter(null)
        setDistance("")
        setModeOfTransportation("road")
        setVehicleType("regular")
        setVehicleNo("")
        setTransportBillDocNo("")
        setTransportBillDocDate("")
    }

    const markAsComplete = () => {

        var object = {}

        object.invoice_id = selectedInvoice.customer_invoice_id;

        object.organization_id = organization_id;
        object.page_name = page_name;

        setMainSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/mark-customer-invoice-as-complete`, object, headers).then((res) => {
            setMainSubmitButtonState(false)
            getBasicInvoicesList(currentPage, rowsPerPage, sortColumn, sortValue, searchValue, startDate, endDate);
            setInvoiceStatusModalShow(false)
            if (res.data.operation === "success") {
                swal("Great!", 'The customer invoice has been successfully marked as completed.', "success")
            }
            else {
                swal("Oops!", res.data.message, "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const transporterSubmit = () => {

        if (transporterName == "") {
            swal("Oops!", "Transporter Name cannot be empty", "error");
            return
        }
        if (transporterId == "") {
            swal("Oops!", "Transporter ID cannot be empty", "error");
            return
        }

        var object = {};

        object.transporter_uid = transporterUid
        object.transporter_name = transporterName
        object.transporter_id = transporterId
        object.gstin_number = ""
        object.gstin_trade_name = ""
        object.address_line1 = ""
        object.address_line2 = ""
        object.country = ""
        object.state = ""
        object.pincode = ""
        object.other_details = ""
        object.organization_id = organization_id;
        object.page_name = page_name;

        // console.log(object);
        setTransporterSubmitButtonState(true)

        if (transporterUid == null) {
            var headers = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "*/*",
                    "token": getCookie("access_token")
                }
            }
            axios.post(`${process.env.REACT_APP_SERVER_URL}/add-transporter`, object, headers).then((res) => {
                setTransporterSubmitButtonState(false)
                if (res.data.operation === "success") {
                    swal("Great!", "Transporter added successfully!", "success")
                    handleTransporterModalClose()
                }
                else {
                    swal("Oops!", res.data.message, "error");
                }
            })
                .catch(function (error) {
                    console.log(error)
                });
        }
        else {
            var headers = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "*/*",
                    "token": getCookie("access_token")
                }
            }
            axios.post(`${process.env.REACT_APP_SERVER_URL}/update-transporter`, object, headers).then((res) => {
                setTransporterSubmitButtonState(false)
                if (res.data.operation === "success") {
                    swal("Great!", "Transporter updated successfully!", "success")
                    handleTransporterModalClose()
                }
                else {
                    swal("Oops!", res.data.message, "error");
                }
            })
                .catch(function (error) {
                    console.log(error)
                });
        }
    }

    const handleTransporterModalClose = () => {
        setTransporterModalShow(false)
        setTransporterList([])
        setTransporterPanel(false)
        setTransporterUid(null)
        setTransporterName("")
        setTransporterId("")

        setSelectedTransporter(null)
    }


    const configurePaymentDetails = (id) => {
        setPaymentLinkListModalShow(true);
        fetchPaymentLinkList(id);
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Customer Invoice list</h1>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        {/* <button className="btn p-0 mx-3 btn-hover-scale">{true ? <i className="bi bi-pin-fill fs-1 px-0"></i> : <i className="bi bi-pin fs-1 px-0"></i>}</button> */}
                        <Tooltip title="SpotERP Docs" >
                            <a
                                href={`${process.env.REACT_APP_SPOTERP_DOCS}/sales/invoice/invoice_list`}
                                className='btn btn-light-primary py-2 px-3'
                                target="_blank"
                            >
                                <i className="bi bi-journal-text fs-1 px-0"></i>
                            </a>
                        </Tooltip>

                        <Tooltip title="Life-cycle Diagram" >
                            <button className='btn btn-light-primary py-2 px-3' onClick={() => { setFlowModalShow(true) }}>
                                <i className="bi bi-question-circle fs-1 px-0"></i>
                            </button>
                        </Tooltip>
                        <Link to={`/create-customer-invoice`} className="btn btn-sm btn-primary me-3 rounded btn-hover-scale">
                            <span className="d-md-none">
                                <svg width="15" height="15" viewBox="0 0 11 11" fill="none">
                                    <path d="M10.8756 6.56H6.50763V10.856H4.49163V6.56H0.123625V4.664H4.49163V0.344H6.50763V4.664H10.8756V6.56Z" fill="#fff">
                                    </path>
                                </svg>
                            </span>
                            <span className="d-none d-md-inline">Create Invoice</span>
                        </Link>
                    </div>
                </div>
                <div>
                    {
                        state === 1 ?
                            <>
                                <div className="row gx-0 gap-5 m-2">
                                    <div className='col-md-3'>
                                        <DateRangePickerComponent
                                            ref={daterange_picker_ref}
                                            allowEdit={false}
                                            showClearButton={false}
                                            focus={() => { daterange_picker_ref.current.show() }}
                                            delayUpdate={true}
                                            presets={[
                                                { label: 'Today', start: new Date(), end: new Date() },
                                                { label: 'Last 7 days', start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date() },
                                                { label: 'Last 30 days', start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },
                                                { label: 'Last 90 days', start: new Date(new Date().setDate(new Date().getDate() - 90)), end: new Date() }
                                            ]}
                                            change={(e) => {
                                                setStartDate(moment(e.startDate).format("YYYY-MM-DD"));
                                                setEndDate(moment(e.endDate).format("YYYY-MM-DD"));
                                            }}
                                            startDate={new Date(startDate)}
                                            endDate={new Date(endDate)}
                                            max={new Date().toISOString().split('T')[0]}
                                        />
                                    </div>
                                    <div className='col-md-5'>
                                        <Select
                                            options={customerList.map(x => ({ cid: x.cid, label: x.customer_display_name + " - " + x.work_phone, value: x.cid }))}
                                            onChange={(val) => {
                                                setCurrentPage(1); // Reset page to 1 on customer filter change
                                                setSelectedCustomer(val);
                                            }}
                                            value={selectedCustomer}
                                            placeholder="Search Customer..."
                                            styles={theme === 'dark' ? dropdownStyleDark : {}}
                                            onInputChange={(val) => { (val.length > search_length) && getCustomers(val); }}
                                            isLoading={customerApiState}
                                            isClearable
                                        />
                                    </div>
                                </div>
                                <div className="card mb-5 mb-xl-8">
                                    <div className="card-body py-3">
                                        <div className='mb-5'>
                                            <input type="text" className='form-control fw-bold border border-primary' value={searchValue || ""} onChange={(e) => { setCurrentPage(1); setSearchValue(e.target.value) }} placeholder='Search...' />
                                        </div>

                                        <div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
                                            {
                                                invoiceListApiState ?
                                                    <div className="spinner-border text-primary w-75px h-75px my-auto"></div>
                                                    :
                                                    invoiceList.length > 0 && branchesList.length > 0 ?
                                                        <>
                                                            <div className="mb-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={listCount}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        if (pageSize !== rowsPerPage) {
                                                                            setCurrentPage(1);
                                                                        }
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                    showQuickJumper={true}
                                                                />
                                                            </div>

                                                            <div className='overflow-auto w-100 flex-grow-1'>
                                                                <table className="table table-row-bordered text-nowrap table-row-gray-100 align-middle gs-0 gy-3 h-preserve-whitespace" style={{ minWidth: "1000px" }}>
                                                                    <thead>
                                                                        <tr className="fw-bold text-muted">
                                                                            <th className="min-w-150px"><TableColumnHead columnKey={'customer_invoice_number'} label={'Invoice Number'} {...{ sortColumn, setSortColumn, sortValue, setSortValue }} /></th>
                                                                            <th className="min-w-150px">Branch</th>
                                                                            <th className="min-w-150px">Reference Number</th>
                                                                            <th className="min-w-150px">Customer Name</th>
                                                                            <th className="min-w-150px"><TableColumnHead columnKey={'grand_total'} label={'Grand Total'} {...{ sortColumn, setSortColumn, sortValue, setSortValue }} /></th>
                                                                            <th className="min-w-150px"><TableColumnHead columnKey={'invoice_date'} label={'Invoice Date'} {...{ sortColumn, setSortColumn, sortValue, setSortValue }} /></th>
                                                                            <th className="min-w-150px"><TableColumnHead columnKey={'due_date'} label={'Due Date'} {...{ sortColumn, setSortColumn, sortValue, setSortValue }} /></th>
                                                                            <th className="min-w-150px">Additional User</th>
                                                                            <th className="min-w-150px">Payment Status</th>
                                                                            <th className="min-w-150px">Progress</th>
                                                                            <th className="min-w-150px">E-Invoice</th>
                                                                            <th className="min-w-150px">E-Way-Bill</th>
                                                                            <th className="min-w-150px"><TableColumnHead columnKey={'add_status'} label={'Status'} {...{ sortColumn, setSortColumn, sortValue, setSortValue }} /></th>
                                                                            <th className="min-w-50px sticky-column" style={{ backdropFilter: 'blur(10px)' }}>Actions</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            invoiceList.map((obj, indx) => {
                                                                                let e_invoice_status = obj.e_invoice_doc.length > 0 ? true : false
                                                                                let e_way_bill_status = obj.e_way_bill_doc.length > 0 ? true : ((obj.e_invoice_doc.length > 0) && (obj.e_invoice_doc[0].e_invoice_data.EwbNo !== null)) ? true : false
                                                                                let id = obj.customer_invoice_id;
                                                                                return (
                                                                                    <tr key={obj.customer_invoice_id}>
                                                                                        <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj.customer_invoice_number}</span></td>
                                                                                        <td><span className="badge badge-light-info">{branchesList.find(x => x.branch_id == obj.branch_id).branch_name}</span></td>
                                                                                        <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj.reference_number ? obj.reference_number : "NA"}</span></td>
                                                                                        <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj.customer_name}</span></td>
                                                                                        <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj.invoice_currency.currency_symbol}&nbsp;{formatNumber(obj.grand_total, { ...formatNumberOptions, currencyFormat: obj.invoice_currency.format, decimalPlaces: obj.invoice_currency.decimal_place })}</span></td>
                                                                                        <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{moment(obj.invoice_date).utcOffset(timezone_change).format("DD-MM-YYYY")}</span></td>
                                                                                        <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{moment(obj.due_date).utcOffset(timezone_change).format("DD-MM-YYYY")}</span></td>
                                                                                        <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj.additional_user_email ? obj.additional_user_email : "NA"}</span></td>
                                                                                        <td>
                                                                                            {obj.payment_logs.find(x => x.log_status === "Pending") === undefined ?
                                                                                                <span className={obj.payment_status === "Paid" ? "badge badge-success" : obj.payment_status === "Unpaid" ? "badge badge-secondary" : "badge badge-primary"}>{obj.payment_status}</span>
                                                                                                :
                                                                                                <span className="badge badge-warning">Pending Payment</span>
                                                                                            }</td>
                                                                                        <td>
                                                                                            <button
                                                                                                style={{
                                                                                                    backgroundColor: '#adb8f0',
                                                                                                    border: '1px solid #c0c0c0',
                                                                                                    borderRadius: '4px',
                                                                                                    padding: '5px 10px',
                                                                                                    cursor: 'pointer',
                                                                                                    transition: 'background-color 0.3s',
                                                                                                }}
                                                                                                onClick={() => {
                                                                                                    setProgressModalShow(true);
                                                                                                    getProgressByStatus(obj.customer_invoice_id)
                                                                                                }}>
                                                                                                <TbProgress />
                                                                                            </button>
                                                                                        </td>
                                                                                        <td>
                                                                                            {
                                                                                                obj.e_invoice_doc.length > 0 ?
                                                                                                    <svg width="24" height="24" viewBox="0 0 122.88 122.88" >
                                                                                                        <path fill="#00A912" d="M34.388,67.984c-0.286-0.308-0.542-0.638-0.762-0.981c-0.221-0.345-0.414-0.714-0.573-1.097 c-0.531-1.265-0.675-2.631-0.451-3.934c0.224-1.294,0.812-2.531,1.744-3.548l0.34-0.35c2.293-2.185,5.771-2.592,8.499-0.951 c0.39,0.233,0.762,0.51,1.109,0.827l0.034,0.031c1.931,1.852,5.198,4.881,7.343,6.79l1.841,1.651l22.532-23.635 c0.317-0.327,0.666-0.62,1.035-0.876c0.378-0.261,0.775-0.482,1.185-0.661c0.414-0.181,0.852-0.323,1.3-0.421 c0.447-0.099,0.903-0.155,1.356-0.165h0.026c0.451-0.005,0.893,0.027,1.341,0.103c0.437,0.074,0.876,0.193,1.333,0.369 c0.421,0.161,0.825,0.363,1.207,0.604c0.365,0.231,0.721,0.506,1.056,0.822l0.162,0.147c0.316,0.313,0.601,0.653,0.85,1.014 c0.256,0.369,0.475,0.766,0.652,1.178c0.183,0.414,0.325,0.852,0.424,1.299c0.1,0.439,0.154,0.895,0.165,1.36v0.23 c-0.004,0.399-0.042,0.804-0.114,1.204c-0.079,0.435-0.198,0.863-0.356,1.271c-0.16,0.418-0.365,0.825-0.607,1.21 c-0.238,0.377-0.518,0.739-0.832,1.07l-27.219,28.56c-0.32,0.342-0.663,0.642-1.022,0.898c-0.369,0.264-0.767,0.491-1.183,0.681 c-0.417,0.188-0.851,0.337-1.288,0.44c-0.435,0.104-0.889,0.166-1.35,0.187l-0.125,0.003c-0.423,0.009-0.84-0.016-1.241-0.078 l-0.102-0.02c-0.415-0.07-0.819-0.174-1.205-0.31c-0.421-0.15-0.833-0.343-1.226-0.575l-0.063-0.04 c-0.371-0.224-0.717-0.477-1.032-0.754l-0.063-0.06c-1.58-1.466-3.297-2.958-5.033-4.466c-3.007-2.613-7.178-6.382-9.678-9.02 L34.388,67.984L34.388,67.984z M61.44,0c16.96,0,32.328,6.883,43.453,17.987c11.104,11.125,17.986,26.493,17.986,43.453 c0,16.961-6.883,32.329-17.986,43.454C93.769,115.998,78.4,122.88,61.44,122.88c-16.961,0-32.329-6.882-43.454-17.986 C6.882,93.769,0,78.4,0,61.439C0,44.48,6.882,29.112,17.986,17.987C29.112,6.883,44.479,0,61.44,0L61.44,0z M96.899,25.981 C87.826,16.907,75.29,11.296,61.44,11.296c-13.851,0-26.387,5.611-35.46,14.685c-9.073,9.073-14.684,21.609-14.684,35.458 c0,13.851,5.611,26.387,14.684,35.46s21.609,14.685,35.46,14.685c13.85,0,26.386-5.611,35.459-14.685s14.684-21.609,14.684-35.46 C111.583,47.59,105.973,35.054,96.899,25.981L96.899,25.981z" />
                                                                                                    </svg>
                                                                                                    :
                                                                                                    <svg width="24" height="24" viewBox="0 0 122.88 122.879">
                                                                                                        <path fill="#EB0110" d="M61.44,0c16.96,0,32.328,6.882,43.453,17.986c11.104,11.125,17.986,26.494,17.986,43.453 c0,16.961-6.883,32.328-17.986,43.453C93.769,115.998,78.4,122.879,61.44,122.879c-16.96,0-32.329-6.881-43.454-17.986 C6.882,93.768,0,78.4,0,61.439C0,44.48,6.882,29.111,17.986,17.986C29.112,6.882,44.48,0,61.44,0L61.44,0z M73.452,39.152 c2.75-2.792,7.221-2.805,9.986-0.026c2.764,2.776,2.775,7.292,0.027,10.083L71.4,61.445l12.077,12.25 c2.728,2.77,2.689,7.256-0.081,10.021c-2.772,2.766-7.229,2.758-9.954-0.012L61.445,71.541L49.428,83.729 c-2.75,2.793-7.22,2.805-9.985,0.025c-2.763-2.775-2.776-7.291-0.026-10.082L51.48,61.435l-12.078-12.25 c-2.726-2.769-2.689-7.256,0.082-10.022c2.772-2.765,7.229-2.758,9.954,0.013L61.435,51.34L73.452,39.152L73.452,39.152z M96.899,25.98C87.826,16.907,75.29,11.296,61.44,11.296c-13.851,0-26.387,5.611-35.46,14.685 c-9.073,9.073-14.684,21.609-14.684,35.459s5.611,26.387,14.684,35.459c9.073,9.074,21.609,14.686,35.46,14.686 c13.85,0,26.386-5.611,35.459-14.686c9.073-9.072,14.684-21.609,14.684-35.459S105.973,35.054,96.899,25.98L96.899,25.98z" />
                                                                                                    </svg>
                                                                                            }
                                                                                        </td>
                                                                                        <td>
                                                                                            {
                                                                                                obj.e_way_bill_doc.length > 0 || ((obj.e_invoice_doc.length > 0) && (obj.e_invoice_doc[0].e_invoice_data.EwbNo !== null)) ?
                                                                                                    <svg width="24" height="24" viewBox="0 0 122.88 122.88" >
                                                                                                        <path fill="#00A912" d="M34.388,67.984c-0.286-0.308-0.542-0.638-0.762-0.981c-0.221-0.345-0.414-0.714-0.573-1.097 c-0.531-1.265-0.675-2.631-0.451-3.934c0.224-1.294,0.812-2.531,1.744-3.548l0.34-0.35c2.293-2.185,5.771-2.592,8.499-0.951 c0.39,0.233,0.762,0.51,1.109,0.827l0.034,0.031c1.931,1.852,5.198,4.881,7.343,6.79l1.841,1.651l22.532-23.635 c0.317-0.327,0.666-0.62,1.035-0.876c0.378-0.261,0.775-0.482,1.185-0.661c0.414-0.181,0.852-0.323,1.3-0.421 c0.447-0.099,0.903-0.155,1.356-0.165h0.026c0.451-0.005,0.893,0.027,1.341,0.103c0.437,0.074,0.876,0.193,1.333,0.369 c0.421,0.161,0.825,0.363,1.207,0.604c0.365,0.231,0.721,0.506,1.056,0.822l0.162,0.147c0.316,0.313,0.601,0.653,0.85,1.014 c0.256,0.369,0.475,0.766,0.652,1.178c0.183,0.414,0.325,0.852,0.424,1.299c0.1,0.439,0.154,0.895,0.165,1.36v0.23 c-0.004,0.399-0.042,0.804-0.114,1.204c-0.079,0.435-0.198,0.863-0.356,1.271c-0.16,0.418-0.365,0.825-0.607,1.21 c-0.238,0.377-0.518,0.739-0.832,1.07l-27.219,28.56c-0.32,0.342-0.663,0.642-1.022,0.898c-0.369,0.264-0.767,0.491-1.183,0.681 c-0.417,0.188-0.851,0.337-1.288,0.44c-0.435,0.104-0.889,0.166-1.35,0.187l-0.125,0.003c-0.423,0.009-0.84-0.016-1.241-0.078 l-0.102-0.02c-0.415-0.07-0.819-0.174-1.205-0.31c-0.421-0.15-0.833-0.343-1.226-0.575l-0.063-0.04 c-0.371-0.224-0.717-0.477-1.032-0.754l-0.063-0.06c-1.58-1.466-3.297-2.958-5.033-4.466c-3.007-2.613-7.178-6.382-9.678-9.02 L34.388,67.984L34.388,67.984z M61.44,0c16.96,0,32.328,6.883,43.453,17.987c11.104,11.125,17.986,26.493,17.986,43.453 c0,16.961-6.883,32.329-17.986,43.454C93.769,115.998,78.4,122.88,61.44,122.88c-16.961,0-32.329-6.882-43.454-17.986 C6.882,93.769,0,78.4,0,61.439C0,44.48,6.882,29.112,17.986,17.987C29.112,6.883,44.479,0,61.44,0L61.44,0z M96.899,25.981 C87.826,16.907,75.29,11.296,61.44,11.296c-13.851,0-26.387,5.611-35.46,14.685c-9.073,9.073-14.684,21.609-14.684,35.458 c0,13.851,5.611,26.387,14.684,35.46s21.609,14.685,35.46,14.685c13.85,0,26.386-5.611,35.459-14.685s14.684-21.609,14.684-35.46 C111.583,47.59,105.973,35.054,96.899,25.981L96.899,25.981z" />
                                                                                                    </svg>
                                                                                                    :
                                                                                                    <svg width="24" height="24" viewBox="0 0 122.88 122.879">
                                                                                                        <path fill="#EB0110" d="M61.44,0c16.96,0,32.328,6.882,43.453,17.986c11.104,11.125,17.986,26.494,17.986,43.453 c0,16.961-6.883,32.328-17.986,43.453C93.769,115.998,78.4,122.879,61.44,122.879c-16.96,0-32.329-6.881-43.454-17.986 C6.882,93.768,0,78.4,0,61.439C0,44.48,6.882,29.111,17.986,17.986C29.112,6.882,44.48,0,61.44,0L61.44,0z M73.452,39.152 c2.75-2.792,7.221-2.805,9.986-0.026c2.764,2.776,2.775,7.292,0.027,10.083L71.4,61.445l12.077,12.25 c2.728,2.77,2.689,7.256-0.081,10.021c-2.772,2.766-7.229,2.758-9.954-0.012L61.445,71.541L49.428,83.729 c-2.75,2.793-7.22,2.805-9.985,0.025c-2.763-2.775-2.776-7.291-0.026-10.082L51.48,61.435l-12.078-12.25 c-2.726-2.769-2.689-7.256,0.082-10.022c2.772-2.765,7.229-2.758,9.954,0.013L61.435,51.34L73.452,39.152L73.452,39.152z M96.899,25.98C87.826,16.907,75.29,11.296,61.44,11.296c-13.851,0-26.387,5.611-35.46,14.685 c-9.073,9.073-14.684,21.609-14.684,35.459s5.611,26.387,14.684,35.459c9.073,9.074,21.609,14.686,35.46,14.686 c13.85,0,26.386-5.611,35.459-14.686c9.073-9.072,14.684-21.609,14.684-35.459S105.973,35.054,96.899,25.98L96.899,25.98z" />
                                                                                                    </svg>
                                                                                            }
                                                                                        </td>
                                                                                        <td><StatusBadge status={obj.add_status} entity={"CUSTOMER_INVOICE"} /></td>
                                                                                        <td className="sticky-column">
                                                                                            <div className="dropdown">
                                                                                                <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                                    <i className="fas fa-bars px-0"></i>
                                                                                                </button>
                                                                                                {
                                                                                                    write &&
                                                                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                                                        {<li className="dropdown-item px-0"><Link className="text-black d-block px-4" to={`/view-customer-invoice/${id}`}>View Invoice Details</Link></li>}
                                                                                                        {(obj.add_status === "CUSTOMER_INVOICE_DRAFT" || obj.add_status === "CUSTOMER_INVOICE_PENDING_APPROVAL" || obj.add_status === "CUSTOMER_INVOICE_FINALIZED") && <li className="dropdown-item px-0"><Link className="text-black d-block px-4" to={`/edit-customer-invoice/${id}`}>Edit Invoice Details</Link></li>}
                                                                                                        {(obj.add_status === "CUSTOMER_INVOICE_PENDING_APPROVAL") && <li className="dropdown-item px-0"><Link className="text-black d-block px-4" to={`/view-customer-invoice/${id}`}>Approve Invoice</Link></li>}
                                                                                                        {(obj.add_status === "CUSTOMER_INVOICE_FINALIZED") && <li className="dropdown-item px-0"><Link className="text-black d-block px-4" to={`/view-customer-invoice/${id}`}>Start Warehouse Processing</Link></li>}
                                                                                                        {(obj.add_status !== "CUSTOMER_INVOICE_COMPLETED" && obj.payment_logs.find(x => x.log_status === "Pending") === undefined && obj.payment_status !== "Paid") && <li className="dropdown-item cursor-pointer" onClick={() => { setInvoiceDetails(obj); configurePaymentDetails(id); }}><span>Send Payment Link</span></li>}
                                                                                                        {(obj.add_status !== "CUSTOMER_INVOICE_COMPLETED" && obj.payment_logs.find(x => x.log_status === "Pending") === undefined && obj.payment_status !== "Paid") && <li className="dropdown-item px-0"><Link className="text-black d-block px-4" to={`/new-payment-received/invoice/${id}`}>Receive Payment</Link></li>}
                                                                                                        {((obj.add_status === "CUSTOMER_INVOICE_FINALIZED" || obj.add_status === "CUSTOMER_INVOICE_WAREHOUSE") && obj.payment_status == "Paid") && <li className="dropdown-item cursor-pointer" onClick={() => { setSelectedInvoice(obj); setInvoiceStatusModalShow(true); getInvoiceStatus(obj.customer_invoice_id); }}>Mark as complete</li>}

                                                                                                        {(!e_invoice_status && !e_way_bill_status) && <li className="dropdown-item cursor-pointer" onClick={() => { setEinvoiceMode("generate_irn"); setConfigGstinListModalShow(true); setSelectedInvoice(obj); }} ><span>Generate IRN number</span></li>}
                                                                                                        {(!e_invoice_status && !e_way_bill_status) && <li className="dropdown-item cursor-pointer" onClick={() => { setEinvoiceMode("generate_irn_with_ewb"); setEwbDetailsModalShow(true); setSelectedInvoice(obj); }}><span>Generate IRN number with EWB details</span></li>}
                                                                                                        {(e_invoice_status && !e_way_bill_status) && <li className="dropdown-item cursor-pointer" onClick={() => { setEinvoiceMode("generate_ewb_against_irn"); setEwbDetailsModalShow(true); setSelectedInvoice(obj); }}><span>Generate EWB against IRN</span></li>}
                                                                                                        {(e_invoice_status && (obj.e_invoice_doc[0].e_invoice_qr_code === null)) && <li className="dropdown-item cursor-pointer" onClick={() => { setEinvoiceMode("get_qr_image"); setConfigGstinListModalShow(true); setSelectedInvoice(obj); }} ><span>Get QR image</span></li>}
                                                                                                        {(e_invoice_status) && <li className="dropdown-item cursor-pointer" onClick={() => {
                                                                                                            swal({
                                                                                                                text: 'Enter the Cancelling Reason',
                                                                                                                content: "input",
                                                                                                                button: { text: "Submit" },
                                                                                                            })
                                                                                                                .then((input) => {
                                                                                                                    if (input === "") {
                                                                                                                        swal("Oops!", "Enter a valid message", "warning")
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        setCancelReason(input)
                                                                                                                        setEinvoiceMode("cancel_irn");
                                                                                                                        setConfigGstinListModalShow(true);
                                                                                                                        setSelectedInvoice(obj);
                                                                                                                    }
                                                                                                                })
                                                                                                        }} ><span>Cancel E-Invoice IRN</span></li>}
                                                                                                        {(e_invoice_status && e_way_bill_status) && <li className="dropdown-item cursor-pointer" onClick={() => {
                                                                                                            swal({
                                                                                                                text: 'Enter the Cancelling Reason',
                                                                                                                content: "input",
                                                                                                                button: { text: "Submit" },
                                                                                                            })
                                                                                                                .then((input) => {
                                                                                                                    if (input === "") {
                                                                                                                        swal("Oops!", "Enter a valid message", "warning")
                                                                                                                    }
                                                                                                                    else {
                                                                                                                        setCancelReason(input)
                                                                                                                        setEinvoiceMode("cancel_irn_ewb");
                                                                                                                        setConfigGstinListModalShow(true);
                                                                                                                        setSelectedInvoice(obj);
                                                                                                                    }
                                                                                                                })
                                                                                                        }} ><span>Cancel E-Invoice EWB</span></li>}
                                                                                                        {(obj.add_status !== "CUSTOMER_INVOICE_DRAFT" && (user.email === "meadoerp@gmail.com" || user.email === "bumba3245@intelmetic.org")) &&
                                                                                                            <li className="dropdown-item cursor-pointer" onClick={() => handleOpenRevertModal(obj)}>Revert Invoice</li>}
                                                                                                    </ul>
                                                                                                }
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                            <div className="mt-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={listCount}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        if (pageSize !== rowsPerPage) {
                                                                            setCurrentPage(1);
                                                                        }
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                    showQuickJumper={true}
                                                                />
                                                            </div>
                                                        </>
                                                        :
                                                        <div className="text-muted fs-2 my-auto text-center">No data to be shown  <br /> <br />
                                                            <button className='btn fs-3 btn-light-primary' onClick={() => { setFlowModalShow(true) }}>
                                                                Need Help <i className="bi bi-question-circle fs-1"></i>
                                                            </button>
                                                        </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            state === 2 ?
                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                :
                                state == 3 ?
                                    <PageError>
                                        <div className="notice bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
                                            <h4 className="text-gray-800 fw-bolder">Create a new Customer Invoice. All added Invoices can be viewed from here</h4>
                                            <div className='mt-10 text-center'>
                                                <Link className='btn btn-success rounded' to={`/create-customer-invoice`}>Create Invoice</Link>
                                            </div>
                                        </div>
                                    </PageError>
                                    :
                                    <PageError>
                                        <div className="notice bg-light-danger rounded border-primary border border-dashed rounded-3 p-6">
                                            <h4 className="text-gray-800 fw-bolder">Something went wrong</h4>
                                            <div className='mt-10 text-center'>
                                                <button className='btn btn-success rounded' onClick={() => { history.go(0) }}>Reload the page</button>
                                            </div>
                                        </div>
                                    </PageError>
                    }
                </div>
            </div>

            <Modal show={invoiceStatusModalShow} onHide={() => { handleInvoiceStatusModalClose(); }} centered>
                <Modal.Header>
                    <Modal.Title>Invoice Status</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleInvoiceStatusModalClose(); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {invoiceStatusApiState === false ?
                        <div className="text-center">
                            <span>Loading...</span>
                            <svg width="50" height="15" viewBox="0 45 100 10">
                                <g transform="translate(20 50)"><circle cx="0" cy="0" r="6" fill="#e15b64"><animateTransform attributeName="transform" type="scale" begin="-0.375s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                <g transform="translate(40 50)"><circle cx="0" cy="0" r="6" fill="#f8b26a"><animateTransform attributeName="transform" type="scale" begin="-0.25s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                <g transform="translate(60 50)"><circle cx="0" cy="0" r="6" fill="#abbd81"><animateTransform attributeName="transform" type="scale" begin="-0.125s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                <g transform="translate(80 50)"><circle cx="0" cy="0" r="6" fill="#81a3bd"><animateTransform attributeName="transform" type="scale" begin="0s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                            </svg>
                        </div>
                        : <>{invoiceStatus !== null &&
                            <>
                                {invoiceStatus.data.length > 0 &&
                                    <div className="table-responsive border-bottom mb-9">
                                        <table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
                                            <thead>
                                                <tr className="border-bottom fs-6 fw-bold text-muted">
                                                    <th className="min-w-100px">Products</th>
                                                    <th className="min-w-100px">Remaining Quantity</th>
                                                </tr>
                                            </thead>
                                            <tbody className="fw-semibold text-gray-600">
                                                {invoiceStatus.data.map((Obj, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                <div className="fw-bold">
                                                                    <div className="fw-bold">{Obj.item_name}</div>

                                                                </div>
                                                            </td>
                                                            <td>{Obj.quantity}</td>
                                                        </tr>
                                                    )
                                                })}

                                            </tbody>
                                        </table>
                                    </div>
                                }
                                {invoiceStatus.operation == "success" ?
                                    <h3>Are you sure about mark as completed?</h3>
                                    :
                                    invoiceStatus.message == "incomplete warehouse processing" ?
                                        <h3>Incomplete warehouse processing needs to be completed.</h3>
                                        :
                                        <h3>The incomplete delivery challan needs to be completed.</h3>
                                }
                            </>
                        }
                        </>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { handleInvoiceStatusModalClose(); }}>Close</button>
                    {(invoiceStatus !== null && invoiceStatus.operation == "success") &&
                        <button className="btn btn-success rounded" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} onClick={() => { markAsComplete() }}>
                            <span className="indicator-label">Proceed</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>}
                </Modal.Footer>
            </Modal >

            <Modal show={paymentLinkListModalShow} onHide={() => { setPaymentLinkListModalShow() }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Payment Link List</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setPaymentLinkListModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {dataFlag == false ?
                        <div>
                            {paymentLinkList.length > 0 ?
                                <div className="table-responsive">
                                    <table className="table align-middle table-row-bordered table-row-solid gy-4 gs-9" id="kt_api_keys_table">
                                        <thead className="border-gray-200 fs-5 fw-semibold bg-lighten">
                                            <tr>
                                                <th className="min-w-100px ps-9">Amount</th>
                                                <th className="min-w-100px px-0">Link Medium</th>
                                                <th className="min-w-100px">Created</th>
                                                <th className="min-w-100px">Status</th>
                                                <th className="min-w-50px sticky-column" style={{ backdropFilter: 'blur(10px)' }}></th>
                                            </tr>
                                        </thead>
                                        <tbody className="fs-6 fw-semibold text-gray-600">
                                            {paymentLinkList.map((obj, index) => {
                                                return (
                                                    <tr>
                                                        <td>{obj.currency == "INR" ? <>Rs.</> : <>Rs.</>}{obj.amount}</td>
                                                        <td><span className="badge badge-secondary">{obj.link_medium}</span></td>
                                                        <td>{moment(obj.add_date_time).format("ll")}</td>
                                                        <td>
                                                            <span className={`badge ${obj.add_status == "Shared" ? "badge-primary" : obj.add_status == "Paid" ? "badge-success" : "badge-danger"} fs-7 fw-semibold`}>{obj.add_status}</span>
                                                        </td>
                                                        <td className="sticky-column">
                                                            {obj.add_status === "Shared" &&
                                                                <div className="dropdown">
                                                                    <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                                        <i className="fas fa-bars px-0"></i>
                                                                    </button>
                                                                    {
                                                                        write &&
                                                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                            {(obj.payment_link !== undefined) &&
                                                                                <li className="dropdown-item px-0"><a className="text-black d-block px-4" target="_blank" href={obj.payment_link}>Pay</a></li>}
                                                                            <li className="dropdown-item cursor-pointer px-0"><a className="text-black d-block px-4" onClick={(e) => { setPaymentLinkDetails(obj); setResendPaymentLinkModalShow(true); }}>Resend</a></li>
                                                                            <li className="dropdown-item cursor-pointer px-0"><a className="text-black d-block px-4" onClick={(e) => { setPaymentLinkDetails(obj); setCancelPaymentLinkModalShow(true); }}>Cancel</a></li>
                                                                        </ul>
                                                                    }
                                                                </div>
                                                            }
                                                        </td>
                                                    </tr>)
                                            })}
                                        </tbody>
                                    </table>
                                </div> :
                                <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
                                    <div className="d-flex flex-stack flex-grow-1">
                                        <div className="fw-bold">
                                            <h4 className="text-gray-800 fw-bolder">No Data Available.</h4>
                                            <div className="fs-6 text-gray-600"> </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        :
                        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setConfigurePaymentModalShow(true); checkPendingPayment() }} className="btn btn-primary" data-bs-dismiss="modal">Send Link</button>
                    <button type="button" onClick={(e) => { setPaymentLinkListModalShow(false) }} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </Modal.Footer>
            </Modal>

            <Modal show={cancelPaymentLinkModalShow} onHide={() => { setCancelPaymentLinkModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Resend Payment Link</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setCancelPaymentLinkModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {paymentLinkDetails !== null &&
                        <center>
                            <div className="form-group row">
                                <div className="col-lg-12">
                                    Current Status is : <span className={`badge ${paymentLinkDetails.add_status == "Shared" ? "badge-primary" : paymentLinkDetails.add_status == "Paid" ? "badge-success" : "badge-danger"} fs-7 fw-semibold`}>{paymentLinkDetails.add_status}</span>
                                    <h3 className="mt-3">Are you sure about cancel payment link?</h3>
                                </div>
                            </div>
                        </center>}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setCancelPaymentLinkModalShow(false) }} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { cancelPaymentLink() }} className="btn btn-danger" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Cancel</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>

            <Modal show={resendPaymentLinkModalShow} onHide={() => { setResendPaymentLinkModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Cancel Payment Link</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setResendPaymentLinkModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {paymentLinkDetails !== null &&
                        <center>
                            <div className="form-group row">
                                <div className="col-lg-12">
                                    Current Status is : <span className={`badge ${paymentLinkDetails.add_status == "Shared" ? "badge-primary" : paymentLinkDetails.add_status == "Paid" ? "badge-success" : "badge-danger"} fs-7 fw-semibold`}>{paymentLinkDetails.add_status}</span>
                                    <h3 className="mt-3">Are you sure about resend payment link?</h3>
                                </div>
                            </div>
                        </center>}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setResendPaymentLinkModalShow(false) }} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { resendPaymentLink() }} className="btn btn-primary" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Resend</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>

            <Modal show={configurePaymentModalShow} onHide={() => { setConfigurePaymentModalShow() }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Send Payment Link</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setConfigurePaymentModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div>

                        {dataFlag == false ?
                            <>
                                <div className="d-flex justify-content-between mb-5">
                                    <div className="col-3 my-auto">
                                        <label className="required fs-5 mb-2">Default Payment Account</label>
                                    </div>
                                    <div className='col-9 my-auto'>
                                        <Select
                                            styles={theme === 'dark' ? dropdownStyleDark : {}}
                                            options={paymentCredentials.map(x => { return { label: `${x.platform} ${x.account_id}`, value: x.account_id } })}
                                            onChange={(val) => {
                                                setDefaultPaymentAccount(val);
                                            }}
                                            value={defaultPaymentAccount}
                                        />
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between mb-5">
                                    <div className="col-3 my-auto">
                                        <label className="required fs-5 mb-2">Link medium</label>
                                    </div>
                                    <div className='col-9 my-auto'>
                                        <Select
                                            styles={theme === 'dark' ? dropdownStyleDark : {}}
                                            options={mediumList.map(x => { return { label: x, value: x } })}
                                            onChange={(val) => {
                                                setLinkMedium(val.value);
                                                if (val.value == "Phone") {
                                                    setMediumValue(customerContactDetails.cusomer_contact_phone);
                                                }
                                                else {
                                                    setMediumValue(customerContactDetails.cusomer_contact_email);
                                                }
                                            }}
                                            value={{ "label": linkMedium, "value": linkMedium }}
                                            isClearable
                                        />
                                    </div>
                                </div>
                                {linkMedium === "Phone" &&
                                    <div className="d-flex justify-content-between mb-5">
                                        <div className="col-3 my-auto">
                                            <label className="required fs-5 mb-2">Phone Medium</label>
                                        </div>
                                        <div className='col-9 my-auto'>
                                            <Select
                                                styles={theme === 'dark' ? dropdownStyleDark : {}}
                                                options={phonemediumList.map(x => { return { label: x, value: x } })}
                                                onChange={(val) => {
                                                    setPhonemedium(val.value);
                                                }}
                                                value={{ "label": phoneMedium, "value": phoneMedium }}
                                                isClearable
                                            />
                                        </div>
                                    </div>
                                }
                                {linkMedium !== "" &&
                                    <div className="d-flex justify-content-between mb-5">
                                        <div className="col-3 my-auto">
                                            <label className="required fs-5 mb-2">{linkMedium === "Phone" ? <>Phone</> : <>Email</>}</label>
                                        </div>
                                        <div className='col-9 my-auto'>
                                            <input className="form-control" type="text" onChange={(e) => { setMediumValue(e.target.value); }} value={mediumValue} />
                                        </div>
                                    </div>
                                }
                                <div className="d-flex justify-content-between mb-5">
                                    <div className="col-3 my-auto">
                                        <label className="fs-5 mb-2">Allow Partial Payment</label>
                                    </div>
                                    <div className='col-9 my-auto'>
                                        <label className="form-check form-switch form-check-custom form-check-solid cursor-pointer">
                                            <input className="form-check-input" type="checkbox" onClick={(e) => { setAllowPartial(e.target.checked); }} checked={allowPartial} />
                                        </label>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between mb-5">
                                    <div className="col-3 my-auto">
                                        <label className="required fs-5 mb-2">Amount</label>
                                    </div>
                                    <div className='col-9 my-auto'>
                                        <input className="form-control" type="number" onChange={(e) => { setAmount(e.target.value); }} value={amount} readOnly={!allowPartial} disabled={!allowPartial} />
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between mb-5">
                                    <div className="col-3 my-auto">
                                        <label className="required fs-5 mb-2">Branch</label>
                                    </div>
                                    <div className='col-9 my-auto'>
                                        <Select
                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                            options={branchList.map((x) => { return { label: x.branch_name, value: x.branch_id } })}
                                            onChange={(val) => {
                                                swal("Alert!", "Please verify applicable taxes for selected items", "info")
                                                setSelectedBranch(val);
                                            }}
                                            value={selectedBranch}
                                            placeholder="Select Branch"
                                        />
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between mb-5">
                                    <div className="col-3 my-auto">
                                        <label className="required fs-5 mb-2">Account Head</label>
                                    </div>
                                    <div className='col-9 my-auto'>
                                        <Select
                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                            options={PaidThroughAccountlist}
                                            onChange={(event) => { setPaidThroughAccount(event); }}
                                            value={PaidThroughAccount}
                                        />
                                    </div>
                                </div>
                            </>
                            // <h3>You have one pending payment. You have three options: clear the payment or cancel it. Would you like to cancel/resend the payment?</h3>
                            :
                            <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setConfigurePaymentModalShow(false) }} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    {
                        write &&
                        <form >
                            <button type="button" onClick={(e) => { sharePaymentLink(e) }} className="btn btn-success" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Share</span>
                                <span className="indicator-progress">Please wait...
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                            </button>
                        </form>
                    }
                </Modal.Footer>
            </Modal>

            <Modal show={ewbDetailsModalShow} onHide={() => { handleEwbDetailsModalClose() }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Choose a GSTIN</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleEwbDetailsModalClose() }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="row gx-0">
                            <div className="col-md-6 px-1 mb-4">
                                <label className="fs-5 fw-bold mb-2">Transporter</label>
                                <Select
                                    options={transporterResults.map(x => { return { label: x.transporter_name, value: x.transporter_uid } })}
                                    onChange={(val) => { setSelectedTransporter(val); }}
                                    value={selectedTransporter}
                                    styles={theme === 'dark' ? dropdownStyleDark : {}}
                                    onInputChange={(val) => { (val.length > 2) && getTransporters(val) }}
                                    onMenuClose={() => { getTransporters(); }}
                                    isLoading={transporterApiState}
                                    components={{
                                        MenuList: (props) => {
                                            return (
                                                <components.MenuList  {...props}>
                                                    {props.children}
                                                    <div className='d-flex justify-content-center'>
                                                        <button className='btn btn-success rounded btn-sm my-1'
                                                            onClick={() => { setTransporterModalShow(true); getAllTransporters(); }}
                                                        ><i className="fa fa-cog" aria-hidden="true"></i>Manage Transporters</button>
                                                    </div>
                                                </components.MenuList >
                                            )
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-md-6 px-1 mb-4">
                                <label className="fs-5 fw-bold mb-2">Distance (in km)</label>
                                <input type="text" className="form-control form-control-solid" value={distance} onChange={(e) => { setDistance(e.target.value) }} />
                            </div>
                        </div>

                        <div className="row gx-0">
                            <div className="col-md-12 px-1 mb-4">
                                <label className="fs-5 fw-bold mb-2">Mode of Transportation</label>
                                <div className='d-flex gap-2'>
                                    <div className='d-flex align-items-center gap-3 p-3 rounded' style={{ border: modeOfTransportation == "road" ? "2px solid #009ef7" : "2px solid #e0e0e0" }} onClick={() => { setModeOfTransportation("road"); setVehicleType("regular"); }} >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 512 512" className="">
                                            <path fill="#1D1D1B" d="M502.2 259.4c-1.2-1.2-3.1-3.2-5.7-5.7-9-9.1-25.9-26.2-47.5-47.4l-.3.3-38.2-100.1c-.7-5.8-4.4-11.2-10.2-15.1-6.8-4.4-14.6-5.6-18.9-5.9-15.4-2-30.9-3.6-46.6-4.8L323 43.3l-6.3-.8c-19.8-2.5-39.9-3.8-59.9-3.8-20.4-.1-40.9 1.3-61.2 3.8l-6.3.8-11.9 37.4c-15.6 1.2-31.2 2.9-46.6 4.8-16 1.1-27.8 9.7-29.1 21L63.3 207.3l-.7-.7-53.2 54.9C2.7 268.4-1 277.5-1 287.1v101.8c0 4.9 3.5 9 8.3 9.9 2.6.4 5.1.9 7.7 1.3v48.8c0 10.2 7.3 18.9 17.4 20.8 12.8 2.3 25.9 3.5 38.9 3.6h1.5c13.5 0 27.2-1.2 40.5-3.7 10-1.8 17.3-10.5 17.3-20.7v-34.3c41.7 3.6 83.7 5.4 125.5 5.4h.3c41.2 0 82.6-1.8 123.7-5.2v34.1c0 10.2 7.3 18.9 17.3 20.7 13.3 2.4 27 3.7 40.5 3.7h1.5c13-.1 26.1-1.3 38.9-3.6 10.1-1.8 17.4-10.6 17.4-20.8v-48.6c3.1-.5 6.1-1 9.2-1.5 4.8-.8 8.3-5 8.3-9.9V285.4c-.2-9.8-4-19-11-26zm-9.2 64.9v9.8l-58.9 3.7 3.9-13.2c1.6-5.6 8.2-10 16.4-11.1l38.7-5.1v15.9zM204.5 61.6c17.3-2 34.9-2.9 52.3-2.9 17 0 34.1 1 51.1 2.9l5.6 17.6c-19-1.1-38.2-1.7-57.3-1.7h-.4c-19 0-38 .6-56.9 1.7l5.6-17.6zm-82.9 49v-1.3c.9-1 4.4-3.4 10.8-3.8l.7-.1c40.2-5.2 81.5-7.8 122.7-7.8h.4c41.3 0 82.7 2.6 123.1 7.8l.7.1c2.9.2 6.9 1 9.6 2.7.7.4 1.1.8 1.3 1.1v1.3l35.7 93.6c-45.1 2.9-121.5 4.9-169.3 5-48.1 0-125.4-2-171.2-5l35.5-93.6zM19 324.3v-16.6l43.4 5.7c8.2 1.1 14.8 5.5 16.4 11.1l3.9 13.2-63.6-4v-9.4zm91.5 91.1v33.4c0 .5-.4 1-.8 1.1-12.6 2.3-25.5 3.4-38.3 3.3-11.9-.1-23.8-1.2-35.5-3.3-.5-.1-.9-.6-.9-1.1v-45.6c25.2 3.8 50.5 7 75.9 9.5-.3.9-.4 1.8-.4 2.7zm365 33.5c0 .5-.4 1-.9 1.1-11.7 2.1-23.6 3.2-35.5 3.3-12.8.1-25.7-1-38.3-3.3-.5-.1-.8-.5-.8-1.1v-33.4c0-.9-.1-1.7-.3-2.5 25.4-2.5 50.7-5.6 75.8-9.4v45.3zm17.5-68.4c-77.9 12.9-157.4 19.4-236.7 19.5h-.3c-79.4 0-159-6.5-237-19.5v-26.7l90.8 5.7L98 318.9c-3.9-13.2-16.8-23.2-33-25.3l-46-6.1v-.3c0-4.4 1.7-8.5 4.7-11.7l50.5-52c43.9 3.4 129.7 5.7 182 5.7h1c51.9 0 137.4-2.4 180.8-5.7 20.1 19.8 35.7 35.6 44.3 44.3 2.6 2.6 4.5 4.6 5.8 5.8 3.2 3.2 4.9 7.4 4.9 11.9v2.7l-41.3 5.5c-16.2 2.1-29.1 12.1-33 25.3l-11.9 40.6 86.1-5.4v26.3z"></path><path fill="#1D1D1B" d="M321.4 336.5c-21.8 2.9-44 4.3-66 4.4-21.6 0-43.4-1.5-64.9-4.4-5.5-.7-10.5 3.1-11.2 8.6-.7 5.5 3.1 10.5 8.6 11.2 22.3 3 45 4.5 67.5 4.5h.6c22.7 0 45.6-1.5 68.1-4.5 5.5-.7 9.3-5.8 8.6-11.2s-5.8-9.4-11.3-8.6z"></path>
                                        </svg>
                                        <span>Road</span>
                                    </div>
                                    <div className='d-flex align-items-center gap-3 p-3 rounded' style={{ border: modeOfTransportation == "rail" ? "2px solid #009ef7" : "2px solid #e0e0e0" }} onClick={() => { setModeOfTransportation("rail"); setVehicleType("regular"); }} >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 512 512" className="">
                                            <path fill="#1D1D1B" d="M256.1 306.3c30.8 0 55.8-25 55.8-55.8 0-30.8-25-55.8-55.8-55.8s-55.8 25-55.8 55.8c0 30.8 25 55.8 55.8 55.8zm36-55.8c0 19.9-16.2 36-36 36-19.9 0-36-16.2-36-36s16.2-36 36-36 36 16.2 36 36z"></path><path fill="#1D1D1B" d="M389.3 390.2h27.3v-19.8H311.8c45.1-21.1 76.5-66.9 76.5-119.9 0-60.4-40.7-111.4-96-127.2 0-26 0-39.8.3-45.2.8-16 5.4-32.9 13.8-50.2l3.9-8-7.6-4.7C293.3 9.4 277.9 2.4 257.9 2c-21.6-.4-38.3 7-48.5 13.3l-7.9 4.9 4.4 8.2c8.9 16.7 14.6 34.8 17 53.6 1.7 13.6 1.6 27.3-.4 40.7-56.7 14.9-98.7 66.6-98.7 127.9 0 53 31.3 98.8 76.5 119.9H95.5v19.8h28.1L87 464.6l169.1 45.5L425 464.6l-35.7-74.4zM237.4 139.6l2 .5c.1-.3.1-.5.2-.8 5.4-.8 10.9-1.2 16.6-1.2 62 0 112.5 50.5 112.5 112.5s-50.5 112.5-112.5 112.5-112.5-50.5-112.5-112.5c-.2-55.7 40.5-102.1 93.7-111zm130 250.6l29.5 61.5L355 463l-29-72.8h41.4zm-62.7 0l31.1 78-69.9 18.8v-96.8h38.8zM246.2 487l-68.1-18.3 31.3-78.5h36.7V487zm-58-96.8l-29.3 73.3-43.6-11.7 30.3-61.6h42.6zm54.3-310.8c-2.2-17.9-7.2-35.2-14.7-51.6 7.3-3.3 17.5-6.4 29.7-6.1 11 .2 20.1 3 27.2 6.3-7.1 16.8-11.1 33.3-11.8 49.2-.3 5.5-.3 18.3-.3 42.1-5.4-.7-10.9-1-16.5-1-4.5 0-8.9.2-13.2.7 1.3-13.2 1.2-26.4-.4-39.6z"></path>
                                        </svg>
                                        <span>Rail</span>
                                    </div>
                                    <div className='d-flex align-items-center gap-3 p-3 rounded' style={{ border: modeOfTransportation == "air" ? "2px solid #009ef7" : "2px solid #e0e0e0" }} onClick={() => { setModeOfTransportation("air"); setVehicleType("regular"); }} >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 512 512" className="">
                                            <path fill="#12100B" d="M512.3 48.6c0-13.1-4.9-24.7-14.4-34.2C488.3 4.8 476.8 0 463.7 0c-32.1 0-62.5 30-63.7 31.3l-72 72L91.5 35.8 36.1 91.1 239 198.6 124 319.2H40.4L-.3 350l112.5 52.9L166.8 512l36.1-39.8v-84.1l115.6-114.5L421 476.2l55.6-55.5L409 184.3l72-72c1.3-1.2 31.3-31.6 31.3-63.7zM387.4 178.7L454.9 415l-29 28.8-102-202.5-139.7 138.8v84.6l-12.5 14-45-90.2-89.9-42.1 10.1-7.4h85.3l138.2-145.1L68 86.3l29-29 236.4 67.5 80-79.9c.3-.3 26.1-25.7 50.2-25.7 8 0 14.7 2.9 20.7 8.8 10.7 10.7 11.6 25.3 2.5 43.5-7.5 15-19 26.8-19.4 27.3l-80 79.9z"></path>
                                        </svg>
                                        <span>Air</span>
                                    </div>
                                    <div className='d-flex align-items-center gap-3 p-3 rounded' style={{ border: modeOfTransportation == "ship" ? "2px solid #009ef7" : "2px solid #e0e0e0" }} onClick={() => { setModeOfTransportation("ship"); setVehicleType("regular"); }} >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 512 512" className="">
                                            <path fill="#1D1E1C" d="M509.9 241.2c1.3-3.1.9-6.6-1-9.4-1.9-2.8-5-4.4-8.3-4.4h-42.3v-85.7c0-5.5-4.5-10-10-10h-26.2v-47c0-5.5-4.5-10-10-10H300.9c-5.5 0-10 4.5-10 10v47H269c-10.6 0-20.6 4.1-28.1 11.5l-52 51.4c-2.5-2.8-4.9-5.7-7.2-8.8l-13.2-18.4c-1.9-2.6-4.9-4.2-8.1-4.2H12.6c-3.4 0-6.5 1.7-8.4 4.5-1.8 2.8-2.2 6.4-.8 9.5l65 150.2c0 .1 0 .1.1.2L71 333c-20.9 11.8-43.3 30.2-66.8 54.7-3.8 4-3.7 10.3.3 14.1 1.9 1.9 4.4 2.8 6.9 2.8 2.6 0 5.3-1 7.2-3.1 47.4-49.4 87.6-70.8 119.6-63.7 13.2 2.9 25.5 10.8 38.6 19.1 21.7 13.7 46.2 29.2 80.5 26.2 10.3-.9 20.5-3.5 30.4-7.5h37.4c-22.1 21.8-43.2 42-74.5 41.5-19.5-.3-34.7-8.4-50.9-16.9-21.5-11.4-43.8-23.1-74.9-14.8-17 4.6-32.7 14.3-46.6 28.7-3.8 4-3.7 10.3.3 14.1 4 3.8 10.3 3.7 14.1-.3 11.3-11.8 23.9-19.6 37.4-23.3 23.5-6.3 40.5 2.7 60.3 13.1 16.7 8.8 35.6 18.8 59.9 19.2h1.4c39.4 0 65.5-25.7 88.6-48.4 21.1-20.8 41.1-40.5 68.8-39.6 27 .9 54.6 21 82.2 59.8 3.2 4.5 9.4 5.6 13.9 2.4 4.5-3.2 5.6-9.4 2.4-13.9-15.1-21.2-30.5-37.6-46.2-48.9 5.9-6.7 10.6-14.4 14-22.6l34.6-84.5zm-199-146.5h91.2v37h-91.2v-37zm-56 62.8c3.8-3.7 8.8-5.8 14.1-5.8h169.4v75.7H262.8c-21.5 0-42.1-7-59.1-19.4l51.2-50.5zm154.9 171.8c-26.1-.8-45.9 11.1-63.5 26.5H214.7c-9.3-4.3-18.1-9.9-27.1-15.6-14-8.8-28.4-18-45-21.7-16.6-3.7-34.6-1.7-53.6 5.9l-2.2-4.9-58.9-136.2h127.3l10.2 14.2c22.5 31.3 58.9 49.9 97.4 49.9h183.1c.8.2 1.6.3 2.5.3s1.7-.1 2.5-.3h35l-28.9 71c-3 7.3-7.5 14-13 19.6-11.4-5.4-22.8-8.4-34.2-8.7z"></path>
                                        </svg>
                                        <span>Ship</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row gx-0">
                            <div className="col-md-6 px-1 mb-4">
                                <label className="fs-5 fw-bold mb-2">Vehicle Type</label>
                                <div className='d-flex gap-3'>
                                    <div className="rounded p-2" style={{ cursor: "pointer", backgroundColor: vehicleType == "regular" ? "#009ef7" : "unset", color: vehicleType == "regular" ? "white" : "black" }} onClick={() => { setVehicleType("regular") }} >Regular</div>
                                    <div className="rounded p-2" style={{ cursor: "pointer", backgroundColor: vehicleType == "over_dimensional_cargo" ? "#009ef7" : "unset", color: modeOfTransportation != "road" ? "grey" : vehicleType == "over_dimensional_cargo" ? "white" : "black" }} onClick={() => { modeOfTransportation == "road" && setVehicleType("over_dimensional_cargo") }} >Over Dimensional Cargo</div>
                                </div>
                            </div>
                            <div className="col-md-6 px-1 mb-4">
                                <label className="fs-5 fw-bold mb-2 required">Vehicle No.</label>
                                <input type="text" className="form-control form-control-solid" value={vehicleNo} onChange={(e) => { setVehicleNo(e.target.value.trim()) }} />
                            </div>
                        </div>
                        <div className="row gx-0">
                            <div className="col-md-6 px-1 mb-4">
                                <label className="fs-5 fw-bold mb-2 required">{modeOfTransportation == "road" ? "Transporter's Doc No." : modeOfTransportation == "rail" ? "RR No." : modeOfTransportation == "air" ? "Airway Bill No." : "Bill of Lading No."}</label>
                                <input type="text" className="form-control form-control-solid" value={transportBillDocNo} onChange={(e) => { setTransportBillDocNo(e.target.value) }} />
                            </div>
                            <div className="col-md-6 px-1 mb-4">
                                <label className="fs-5 fw-bold mb-2 required">{modeOfTransportation == "road" ? "Transporter's Doc Date" : modeOfTransportation == "rail" ? "RR Date" : modeOfTransportation == "air" ? "Airway Bill Date" : "Bill of Lading Date"}</label>
                                <input type="date" className="form-control form-control-solid" value={transportBillDocDate} onChange={(e) => { setTransportBillDocDate(e.target.value) }} />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { handleEwbDetailsModalClose() }}>Close</button>
                    <button className="btn btn-success rounded" onClick={() => { setEwbDetailsModalShow(false); setConfigGstinListModalShow(true); }}>Proceed</button>
                </Modal.Footer>
            </Modal>

            <Modal show={configGstinListModalShow} onHide={() => { handleConfigGstinListModalClose() }} centered>
                <Modal.Header>
                    <Modal.Title>Choose a GSTIN</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleConfigGstinListModalClose() }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ backgroundColor: "#f4f6f9" }}>
                    <div className='container'>
                        {
                            configGstinList.length === 0 ?
                                <div className="overflow-auto pb-5">
                                    <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed min-w-lg-600px flex-shrink-0 p-6">
                                        <span className="svg-icon svg-icon-2tx svg-icon-primary me-4">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.3" d="M19.0687 17.9688H11.0687C10.4687 17.9688 10.0687 18.3687 10.0687 18.9688V19.9688C10.0687 20.5687 10.4687 20.9688 11.0687 20.9688H19.0687C19.6687 20.9688 20.0687 20.5687 20.0687 19.9688V18.9688C20.0687 18.3687 19.6687 17.9688 19.0687 17.9688Z" fill="currentColor"></path>
                                                <path d="M4.06875 17.9688C3.86875 17.9688 3.66874 17.8688 3.46874 17.7688C2.96874 17.4688 2.86875 16.8688 3.16875 16.3688L6.76874 10.9688L3.16875 5.56876C2.86875 5.06876 2.96874 4.46873 3.46874 4.16873C3.96874 3.86873 4.56875 3.96878 4.86875 4.46878L8.86875 10.4688C9.06875 10.7688 9.06875 11.2688 8.86875 11.5688L4.86875 17.5688C4.66875 17.7688 4.36875 17.9688 4.06875 17.9688Z" fill="currentColor"></path>
                                            </svg>
                                        </span>
                                        <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                                            <div className="mb-3 mb-md-0 fw-semibold">
                                                <h4 className="text-gray-900 fw-bold">No Gstin Configured yet.</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="d-flex flex-column gap-5">
                                    {
                                        configGstinList.sort((a, b) => a.add_date_time - b.add_date_time).map((obj, index) => {
                                            return (
                                                <div key={index} className="position-relative fv-row w-100 flex-md-root" style={{ cursor: "pointer" }} onClick={() => { setSelectedOrganizationGstin(obj.gstin_uid); }}>
                                                    <div className="card card-flush h-lg-100">
                                                        <div className="card-header mt-6">
                                                            <div className="card-title flex-column"><h3 className="fw-bolder mb-1">{obj.gstin_number}</h3></div>
                                                        </div>
                                                        <div className="d-flex flex-wrap">
                                                            <div className="card-body p-9">
                                                                <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                    <div className="fs-6 fw-bold text-gray-700">{obj.legal_name}</div>
                                                                    <div className="fw-semibold text-gray-400">Business Legal Name</div>
                                                                </div>
                                                                <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                    <div className="fs-6 fw-bold text-gray-700">{obj.trade_name}</div>
                                                                    <div className="fw-semibold text-gray-400">Business Trade Name</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        selectedOrganizationGstin != null && selectedOrganizationGstin === obj.gstin_uid &&
                                                        <div className='position-absolute' style={{ top: "2.8rem", right: "11rem" }} >
                                                            <svg width="30" height="30" viewBox="0 0 64 64">
                                                                <path d="M32,2C15.431,2,2,15.432,2,32c0,16.568,13.432,30,30,30c16.568,0,30-13.432,30-30C62,15.432,48.568,2,32,2z M25.025,50  l-0.02-0.02L24.988,50L11,35.6l7.029-7.164l6.977,7.184l21-21.619L53,21.199L25.025,50z" fill="#43a047" />
                                                            </svg>
                                                        </div>
                                                    }
                                                </div>
                                            )
                                        })
                                    }
                                </div>

                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { handleConfigGstinListModalClose() }}>Close</button>
                    <button className="btn btn-success rounded" data-kt-indicator={einvoiceSubmitButtonState ? "on" : "off"} disabled={einvoiceSubmitButtonState} onClick={() => { processEinvoice() }}>
                        <span className="indicator-label">Proceed</span>
                        <span className="indicator-progress">Please wait...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal show={transporterModalShow} onHide={() => { handleTransporterModalClose(); }} centered>
                <Modal.Header>
                    <Modal.Title>Manage Transporters</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleTransporterModalClose(); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        {
                            transporterPanel ?
                                <div className='container rounded p-1' style={{ backgroundColor: "#bcd2f2" }}>
                                    <div className="row mb-5 gx-0">
                                        <div className="col-6 px-1">
                                            <label className="fs-5 fw-bold mb-2 required">Name</label>
                                            <input type="text" className="form-control form-control-solid" value={transporterName} onChange={(e) => { setTransporterName(e.target.value.trim()) }} />
                                        </div>
                                        <div className="col-6 px-1">
                                            <label className="fs-5 fw-bold mb-2 required">Transporter ID</label>
                                            <input type="text" className="form-control form-control-solid" value={transporterId} onChange={(e) => { setTransporterId(e.target.value.trim()) }} />
                                        </div>
                                    </div>
                                    <div className="d-flex gap-1">
                                        {
                                            write &&
                                            <button className="btn btn-primary btn-sm py-2 px-3" data-kt-indicator={transporterSubmitButtonState ? "on" : "off"} disabled={transporterSubmitButtonState} onClick={() => { transporterSubmit() }}>
                                                <span className="indicator-label">Save</span>
                                                <span className="indicator-progress">Please wait...
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </span>
                                            </button>
                                        }
                                        <button className='btn btn-secondary btn-sm py-2 px-3' onClick={() => { setTransporterPanel(false); setTransporterUid(null); setTransporterName(""); setTransporterId(""); }}>Cancel</button>
                                    </div>
                                </div>
                                :
                                <div><button className='btn btn-success btn-sm' onClick={() => { setTransporterPanel(true); setTransporterUid(null); setTransporterName(""); setTransporterId(""); }}>+ Add New Transporter</button></div>
                        }

                        <hr />
                        <div className="row mb-2 gx-0">
                            <div className="col-6"><span className="fs-5 fw-bold mb-2">Name</span></div>
                            <div className="col-6"><span className="fs-5 fw-bold mb-2">Transporter ID</span></div>
                        </div>
                        {
                            transporterList.length == 0 ? <div className='text-gray-600'>No transporters added yet</div> :
                                transporterList.map((x, i) => {
                                    return (
                                        <div key={i} className="row mb-1 gx-0">
                                            <div className="col-6 mb-2"><span className="fs-5 mb-2">{x.transporter_name}</span></div>
                                            <div className="col-5"><span className="fs-5 mb-2">{x.transporter_id}</span></div>
                                            <div className="col-1">
                                                <button onClick={(e) => { setTransporterPanel(true); setTransporterUid(x.transporter_uid); setTransporterName(x.transporter_name); setTransporterId(x.transporter_id); }} className="btn btn-sm px-3">
                                                    <i className="fa-solid fa-pencil fs-2 text-hover-success"></i>
                                                </button>
                                            </div>
                                        </div>
                                    )
                                })
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { handleTransporterModalClose() }}>Close</button>
                </Modal.Footer>
            </Modal>


            <Modal show={progressModalShow} onHide={() => { setProgressModalShow(false); setProgressStatus([]); }} centered>
                <Modal.Body>

                    {flowApiState === true && (
                        <div className="text-center">
                            <span>Loading...</span>
                            <svg width="50" height="15" viewBox="0 45 100 10">
                                <g transform="translate(20 50)"><circle cx="0" cy="0" r="6" fill="#e15b64"><animateTransform attributeName="transform" type="scale" begin="-0.375s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                <g transform="translate(40 50)"><circle cx="0" cy="0" r="6" fill="#f8b26a"><animateTransform attributeName="transform" type="scale" begin="-0.25s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                <g transform="translate(60 50)"><circle cx="0" cy="0" r="6" fill="#abbd81"><animateTransform attributeName="transform" type="scale" begin="-0.125s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                <g transform="translate(80 50)"><circle cx="0" cy="0" r="6" fill="#81a3bd"><animateTransform attributeName="transform" type="scale" begin="0s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                            </svg>
                        </div>
                    )}

                    {flowApiState === false && (
                        <>

                            <div className="position-absolute top-0 end-0 p-5">
                                <div onClick={() => { setProgressModalShow(false); setProgressStatus([]) }} className="cursor-pointer">
                                    <i className="bi bi-x-circle fs-1 text-danger"></i>
                                </div>
                            </div>
                            <div className='container mt-6'>
                                {progressStatus.customer_delivery_challan_data &&
                                    progressStatus.customer_delivery_challan_data.length > 0 &&
                                    progressStatus.customer_delivery_challan_data.some(challan =>
                                        challan.customer_delivery_challan_status_logs &&
                                        challan.customer_delivery_challan_status_logs.some(obj => obj.delivery_challan_status === "DELIVERY_DISPATCHED")
                                    ) && (
                                        <div className="alert alert-success mb-4">
                                            <strong>Flow Completed:</strong> The delivery has been dispatched.
                                        </div>
                                    )
                                }
                                <Timeline>
                                    {/* {progressStatus.customer_order_data &&
                                        progressStatus.customer_order_data.customer_order_status_logs &&
                                        progressStatus.customer_order_data.customer_order_status_logs.map((obj) => (
                                            <Timeline.Item key={obj._id} color="green">
                                                <div className="d-flex flex-wrap">
                                                    <div className="d-flex flex-column ps-3" style={{ maxWidth: "150px" }}>
                                                        <p className={`fw-bold text-${obj.customer_order_status === "CUSTOMER_ORDER_PENDING_APPROVAL" ? "success" : obj.customer_order_status === "CUSTOMER_ORDER_FINALIZED" ? "success" : obj.customer_order_status === "CUSTOMER_ORDER_DRAFT" ? "success" : obj.customer_order_status === "CUSTOMER_ORDER_INVOICED" ? "success" : obj.customer_order_status === "CUSTOMER_ORDER_CANCELLED" && "success"} mb-0`}>
                                                            {
                                                                obj.customer_order_status
                                                                    .replace(/CUSTOMER_ORDER_/i, '')
                                                                    .replace(/_/g, ' ')
                                                                    .toLowerCase()
                                                                    .split(' ')
                                                                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                                                                    .join(' ')
                                                            }
                                                        </p>
                                                        <p className="fw-mormal timeline-content text-muted mb-0">
                                                            {
                                                                obj.operation_message
                                                                    .replace(/Successfully/i, '')
                                                                    .replace(/_/g, ' ')
                                                            }
                                                        </p>
                                                    </div>
                                                    <div className="d-flex flex-column align-items-center ps-5">
                                                        <p className="fw-bold text-gray-800 fs-6 mb-0">Assigned Date</p>
                                                        <p className="fw-bold text-gray-800 fs-6">{moment(obj.timestamp).utcOffset(timezone_change).format("lll")}</p>
                                                    </div>
                                                </div>
                                            </Timeline.Item>
                                        ))} */}

                                    {!progressStatus.customer_invoice_data ||
                                        (progressStatus.customer_invoice_data &&
                                            !progressStatus.customer_invoice_data.customer_invoice_status_logs) ? (
                                        <Timeline.Item color="red" dot={<ClockCircleOutlined />}>
                                            <div className="d-flex flex-wrap">
                                                <div className="d-flex flex-column ps-3" style={{ maxWidth: "150px" }}>
                                                    <p className="fw-bold text-muted mb-0">Invoice: Processing pending </p>
                                                </div>
                                            </div>
                                        </Timeline.Item>
                                    ) : (
                                        progressStatus.customer_invoice_data.customer_invoice_status_logs.map((obj) => (
                                            <Timeline.Item key={obj._id} color="green">
                                                <div className="d-flex flex-wrap">
                                                    <div className="d-flex flex-column ps-3" style={{ maxWidth: "150px" }}>
                                                        {/* <p className={
                                                            `fw-bold text-${(obj.invoice_status || obj.customer_invoice_status) === "CUSTOMER_INVOICE_PENDING_APPROVAL"
                                                                ? "success"
                                                                : (obj.invoice_status || obj.customer_invoice_status) === "CUSTOMER_INVOICE_FINALIZED"
                                                                    ? "success"
                                                                    : (obj.invoice_status || obj.customer_invoice_status) === "CUSTOMER_INVOICE_DRAFT"
                                                                        ? "success"
                                                                        : (obj.invoice_status || obj.customer_invoice_status) === "CUSTOMER_INVOICE_WAREHOUSE"
                                                                            ? "success"
                                                                            : (obj.invoice_status || obj.customer_invoice_status) === "CUSTOMER_INVOICE_CANCELLED" && "success"
                                                            } mb-0`
                                                        }> */}
                                                        <p className={
                                                            `fw-bold text-${(obj.invoice_status || obj.customer_invoice_status) === "CUSTOMER_INVOICE_PENDING_APPROVAL"
                                                                ? "success"
                                                                : (obj.invoice_status || obj.customer_invoice_status) === "CUSTOMER_INVOICE_FINALIZED"
                                                                    ? "success"
                                                                    : (obj.invoice_status || obj.customer_invoice_status) === "CUSTOMER_INVOICE_DRAFT"
                                                                        ? "success"
                                                                        : (obj.invoice_status || obj.customer_invoice_status) === "CUSTOMER_INVOICE_WAREHOUSE"
                                                                            ? "success"
                                                                            : (obj.invoice_status || obj.customer_invoice_status) === "CUSTOMER_INVOICE_CANCELLED" && "success"
                                                            } mb-0`
                                                        }>
                                                            {
                                                                (obj.invoice_status || obj.customer_invoice_status)
                                                                    .replace(/CUSTOMER_INVOICE_/i, '')
                                                                    .replace(/_/g, ' ')
                                                                    .toLowerCase()
                                                                    .split(' ')
                                                                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                                                                    .join(' ')
                                                            }
                                                        </p>
                                                        <p className="fw-mormal timeline-content text-muted mb-0">
                                                            {
                                                                obj.operation_message
                                                                    .replace(/Successfully/i, '')
                                                                    .replace(/_/g, ' ')
                                                            }
                                                        </p>
                                                    </div>
                                                    <div className="d-flex flex-column align-items-center ps-5">
                                                        <p className="fw-bold text-gray-800 fs-6 mb-0">Assigned Date</p>
                                                        <p className="fw-bold text-gray-800 fs-6">{moment(obj.timestamp).utcOffset(timezone_change).format("lll")}</p>
                                                    </div>
                                                </div>
                                            </Timeline.Item>
                                        ))
                                    )}

                                    {!progressStatus.customer_warehouse_processing_data ||
                                        (progressStatus.customer_warehouse_processing_data &&
                                            !progressStatus.customer_warehouse_processing_data.customer_warehouse_processing_status_logs) ? (
                                        <Timeline.Item color="red" dot={<ClockCircleOutlined />}>
                                            <div className="d-flex flex-wrap">
                                                <div className="d-flex flex-column ps-3" style={{ maxWidth: "150px" }}>
                                                    <p className="fw-bold text-muted mb-0">Warehouse: Processing pending</p>
                                                </div>
                                            </div>
                                        </Timeline.Item>
                                    ) : (
                                        progressStatus.customer_warehouse_processing_data.customer_warehouse_processing_status_logs.map((obj) => (
                                            <Timeline.Item key={obj._id} color="green">
                                                <div className="d-flex flex-wrap">
                                                    <div className="d-flex flex-column ps-3" style={{ maxWidth: "150px" }}>
                                                        <p className={`fw-bold text-${obj.warehouse_processing_status === "CUSTOMER_WAREHOUSE_PROCESSING_INIT" ? "success" : obj.warehouse_processing_status === "CUSTOMER_WAREHOUSE_PROCESSING_PARTIAL" ? "success" : obj.warehouse_processing_status === "CUSTOMER_WAREHOUSE_PROCESSED" && "success"} mb-0`}>
                                                            {
                                                                obj.warehouse_processing_status
                                                                    .replace(/CUSTOMER_WAREHOUSE/i, '')
                                                                    .replace(/_/g, ' ')
                                                                    .toLowerCase()
                                                                    .split(' ')
                                                                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                                                                    .join(' ')
                                                            }
                                                        </p>
                                                        <p className="fw-mormal timeline-content text-muted mb-0">
                                                            {
                                                                obj.operation_message
                                                                    .replace(/Successfully/i, '')
                                                                    .replace(/_/g, ' ')
                                                            }
                                                        </p>
                                                    </div>
                                                    <div className="d-flex flex-column align-items-center ps-5">
                                                        <p className="fw-bold text-gray-800 fs-6 mb-0">Assigned Date</p>
                                                        <p className="fw-bold text-gray-800 fs-6">{moment(obj.timestamp).utcOffset(timezone_change).format("lll")}</p>
                                                    </div>
                                                </div>
                                            </Timeline.Item>
                                        ))
                                    )}

                                    {!progressStatus.customer_delivery_challan_data ||
                                        (progressStatus.customer_delivery_challan_data &&
                                            progressStatus.customer_delivery_challan_data.length <= 0) ? (
                                        <Timeline.Item color="red" dot={<ClockCircleOutlined />}>
                                            <div className="d-flex flex-wrap">
                                                <div className="d-flex flex-column ps-3" style={{ maxWidth: "150px" }}>
                                                    <p className="fw-bold text-muted mb-0">Chalan: Processing pending</p>
                                                </div>
                                            </div>
                                        </Timeline.Item>
                                    ) : (
                                        progressStatus.customer_delivery_challan_data.map((challan) =>
                                            challan.customer_delivery_challan_status_logs &&
                                            challan.customer_delivery_challan_status_logs.map((obj) => (
                                                <Timeline.Item key={obj._id} color="green" dot={<CheckCircleOutlined />}>
                                                    <div className="d-flex flex-wrap">
                                                        <div className="d-flex flex-column ps-3" style={{ maxWidth: "150px" }}>
                                                            <p className={`fw-bold text-${obj.delivery_challan_status === "DELIVERY_DISPATCHED" && "success"} mb-0`}>
                                                                {
                                                                    obj.delivery_challan_status
                                                                        .replace(/_/g, ' ')
                                                                        .toLowerCase()
                                                                        .split(' ')
                                                                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                                                                        .join(' ')
                                                                }
                                                            </p>
                                                            <p className="fw-mormal timeline-content text-muted mb-0">
                                                                {
                                                                    obj.operation_message
                                                                        .replace(/Successfully/i, '')
                                                                        .replace(/_/g, ' ')
                                                                }
                                                            </p>
                                                        </div>
                                                        <div className="d-flex flex-column align-items-center ps-5">
                                                            <p className="fw-bold text-gray-800 fs-6 mb-0">Assigned Date</p>
                                                            <p className="fw-bold text-gray-800 fs-6">{moment(obj.timestamp).utcOffset(timezone_change).format("lll")}</p>
                                                        </div>
                                                    </div>
                                                </Timeline.Item>
                                            ))
                                        )
                                    )}
                                </Timeline>

                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal >

            <Modal show={flowModalShow} onHide={() => { setFlowModalShow(false) }} dialogClassName="h-modal-80">
                <Modal.Header>
                    <Modal.Title>
                        <span className='text-gray-500'>Order Flow Cycle</span>
                    </Modal.Title>

                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setFlowModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <img src={'./images/flow_images/customer-invoice.png'} className='w-100' alt="Not yet provided" />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { setFlowModalShow(false) }}>Cancel</button>
                </Modal.Footer>
            </Modal >
        </>
    );
};

export default CustomerInvoiceList;
